import React from 'react';
import { SnackbarProviderContext } from './Snackbar.helpers';

export default React.createContext<SnackbarProviderContext>({
  openSnackbar: () => {},
  closeSnackbar: () => {},
});
